import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import SimpleNav from "./SimpleNav";
import SimpleTabContent from "./SimpleTabContent";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { SimpleTabTitle } from "../../../../Constants/Constants";
import { SimpleTabSubTitle } from "../../../../Data/UiKits/Tabs";

const SimpleTab = () => {
  const [basicTab, setBasicTab] = useState("2");
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={SimpleTabTitle} span={SimpleTabSubTitle} />
        <CardBody>
          <SimpleNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <SimpleTabContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default SimpleTab;
